import type { Todo } from "../../domain/entities.ts";

export function dependencyOrder(tasks: Todo[]): Todo[] {
  const byId = new Map(tasks.map(task => [task.id, task]));
  const result: Todo[] = [];
  const visited = new Set<string>();
  const visit = (task: Todo) => {
    if (visited.has(task.id)) return;
    visited.add(task.id);
    (task.dependencyIds || []).map(id => byId.get(id)).filter((item): item is Todo => !!item).forEach(visit);
    result.push(task);
  };
  tasks.forEach(visit);
  return result;
}
